import { NoResult } from '@devex/devex-shared';
import { HttpService } from './http-service';

export class StatesAndProvincesService {
	public static readonly id = 'states-and-provinces-service';

	public constructor(private readonly _httpService: HttpService) {}

	public async get(): Promise<{ enabledProvinces: string[] }> {
		const response = await this._httpService.get<{ enabledProvinces: string[] }>('api/provinces-config');

		return response;
	}

	public async save(provincesConfig: string[]): Promise<NoResult> {
		await this._httpService.put('api/provinces-config', provincesConfig);

		return NoResult.instance;
	}
}
